import { DayScheduleType, TimeMode } from "../__generated__/graphql";

export const isNotEmptyDaySchedule = (daySchedule?: DayScheduleType | null) => {
    if (!daySchedule) {
        return false;
    }
    if (daySchedule.timeMode === TimeMode.Fixed) {
        return (daySchedule.fixedTimes?.length || 0) > 0;
    }
    if (daySchedule.timeMode === TimeMode.Free) {
        return (daySchedule.freeDurations?.length || 0) > 0;
    }
    return false;
};
